<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'mb-4 ' + config!.cssClass : 'form-group'"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}

    @if (config ? showAsterisk(config) : false) {
      *
    }
  </label>

  <div class="input-group">
    <input
      type="text"
      class="form-control"
      [attr.placeholder]="config?.placeholder"
      [formControlName]="config?.name ?? null"
      [ngClass]="{ 'is-valid': valid, 'is-invalid': invalid }"
      [id]="config?.name"
      [attr.data-testid]="config?.name"
      [attr.aria-describedby]="config?.name + 'err'"
    />
    <button
      class="btn btn-colour-blue-600"
      type="button"
      [attr.data-testid]="config?.inputGroupAddOnLabel + 'Btn'"
      (click)="config?.inputGroupAddOnHandler?.()"
    >
      {{ config?.inputGroupAddOnLabel }}
    </button>
  </div>

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
